import {Component, computed, input} from '@angular/core';
import {AppNumberPipe} from '@frontend/shared';
import {TableModule} from 'primeng/table';
import {TranslocoPipe} from '@jsverse/transloco';
import {TranslateDirectusPipe} from '@frontend/transloco';
import {
  CompanyEmployeeContainer,
  CompanyEmployeeSummaryData,
  NUMERIC_FIELDS,
} from './company-employee.types';
import {AppPanelComponent} from '../../../../../../../../shared/components/header/panel/app-panel.component';

const EMPTY_SUMMARY: CompanyEmployeeSummaryData = {
  salariedHeadcount: 0,
  industrialHeadcount: 0,
  contingentHeadcount: 0,
  totalHeadcount: 0,
  totalFte: 0,
};

@Component({
  selector: 'app-company-employee-info-module',
  imports: [TableModule, TranslocoPipe, AppNumberPipe, AppPanelComponent],
  templateUrl: './company-employee-info.component.html',
  providers: [TranslateDirectusPipe],
})
export class CompanyEmployeeInfoComponent {
  inputObject = input.required<CompanyEmployeeContainer[]>();

  summaryData = computed<CompanyEmployeeSummaryData>(() =>
    this.inputObject().reduce(
      (summary, item) => {
        NUMERIC_FIELDS.forEach((field) => {
          summary[field] += item[field] ?? 0;
        });
        return summary;
      },
      {...EMPTY_SUMMARY},
    ),
  );
}
